import { render, staticRenderFns } from "./SubprocessNodeConfig.vue?vue&type=template&id=c0543f82&scoped=true"
import script from "./SubprocessNodeConfig.vue?vue&type=script&lang=js"
export * from "./SubprocessNodeConfig.vue?vue&type=script&lang=js"
import style0 from "./SubprocessNodeConfig.vue?vue&type=style&index=0&id=c0543f82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0543f82",
  null
  
)

export default component.exports